module.exports = __webpack_public_path__ + "static/media/plusicon.2ccfec94.svg";